export default __webpack_public_path__ + "static/media/6A2_at_2020-13-1.5d893b5c.png";